<template>
  <div>
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>展会管理</BreadcrumbItem>
          <BreadcrumbItem to="/host/index/act/act-home">活动管理</BreadcrumbItem>
          <BreadcrumbItem>直播间</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">直播间</div>
      </div>
      <div class="f-tar" style="padding-top: 37px;">
        <Button @click="$router.push('/host/index/act/act-home')">返回</Button>
      </div>
    </div>

    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs" name="tabs-live">
        <TabPane label="直播设置" name="1" tab="tabs-live">
          <hostActivityLiveSet ref="hostActivityLiveSet" v-if="showTabs === '1'"></hostActivityLiveSet>
        </TabPane>
        <TabPane label="数据统计" name="2" tab="tabs-live">
          <hostActivityLiveData ref="hostActivityLiveData"  v-if="showTabs === '2'"></hostActivityLiveData>
        </TabPane> 
        <TabPane label="直播回放" name="3" tab="tabs-live" v-if="activity && activity.isOpenBlackLive">
          <hostActivityLiveLibrary ref="hostActivityLiveLibrary"  v-if="showTabs === '3'"></hostActivityLiveLibrary>
        </TabPane>
      </Tabs>
    </div>

  </div>
</template>

<script>
import hostActivityLiveSet from "./host-activity-live-set/host-activity-live-set.vue";
import hostActivityLiveLibrary from "./host-activity-live-library/host-activity-live-library.vue";
import hostActivityLiveData from "./host-activity-live-data";
import { mapActions, mapMutations, mapGetters } from "vuex";
export default {
  name: 'host-activity-live',
  components: {
    hostActivityLiveSet,
    hostActivityLiveData,
    hostActivityLiveLibrary,
  },
  data () {
    return {
      showTabs: "1",
    };
  },
  computed: {
    ...mapGetters({
      activity: 'liveModule/getActivity',
    }),
    query () {
      return this.$route.query;
    },
    channelId () {
      return this.query.channelId;
    },
    activityId () {
      return this.query.activityId;
    }, 
  },
  methods: {
    ...mapMutations({
      setChannel: 'liveModule/setChannel',
    }),
    ...mapActions({
      channelQuery: 'liveModule/channelQuery',
    }),
    async init () {
      if (!this.channelId) return;
      let res = await this.channelQuery(this.channelId);
      console.log('channelQuery', res);
      if (res.code === 200 && res.status === 'success') {
        this.setChannel(res.data);
      }
    },
    switchBrand (name) {
      let channelId = this.query.channelId || '';
      if (name === "1") {
        this.$router.push(`${this.$route.path}?type=live${channelId ? '&channelId=' + channelId : ''}&activityId=${this.activityId}`);
      } else if (name === "2") {
        this.$router.push(`${this.$route.path}?type=data${channelId ? '&channelId=' + channelId : ''}&activityId=${this.activityId}`);
      } else if (name === "3") {
        this.$router.push(`${this.$route.path}?type=library${channelId ? '&channelId=' + channelId : ''}&activityId=${this.activityId}`);
      }
    },
    changeTab () {
      if (this.query && this.query.type && this.query.type === "live") {
        this.showTabs = "1";
      } else if (this.query && this.query.type && this.query.type === "data") {
        this.showTabs = "2";
      } else if (this.query && this.query.type && this.query.type === "library") {
        this.showTabs = "3";
      }
    },
  },
  created () {
    this.changeTab();
    this.init();
  }
}

</script>

<style lang="scss" scoped>

</style>
